'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _error = require('../error/error'); // Helpers


var fields = ['display', 'input', 'api']; // Error

exports.default = function (field) {
  if (!fields.includes(field)) throw (0, _error.systemError)('Invalid field "' + field + '"');
};